import React from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import ContentModal from './ContentModal';
import ReactModal from './ReactModal';

const modalUrlMap: { [key: string]: string } = {
  //INFORMATION_AND_ASSUMPTIONS: '/content/workplace/en/participant/ri/modals/information-and-assumptions',
};

class Modal extends React.Component {
  props: any;

  render(): any {
    const { selectedModalName } = this.props;
    return (
      <React.Fragment>
        {selectedModalName && modalUrlMap[selectedModalName] && (
          <ContentModal pageUrl={modalUrlMap[selectedModalName]} />
        )}
        {selectedModalName && !modalUrlMap[selectedModalName] && <ReactModal modalName={selectedModalName} />}{' '}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ modal }: any) => {
  return {
    selectedModalName: modal.selectedModalName,
  };
};

export default connect(mapStateToProps, { hideModal: modalActions.hideModal })(Modal);
